export const SAPA_SET_USER = 'SAPA_SET_USER';
export const SAPA_RESET = 'SAPA_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
